module.exports = __webpack_public_path__ + "img/02.f42496e2.png";